// extracted by mini-css-extract-plugin
export default {"background_wrapper":"BackgroundWatchlist_background_wrapper__NikVQ","wrapper":"BackgroundWatchlist_wrapper__f0MLv"};